<script>
import options from './FormAddressField.options'
export default options
</script>

<template>
    <div class="kb-form-address-field-group__input-wrapper FormTextbox"
        :class="{ 'kb-form-address-field-group--disabled': disabled, 'ValidationRequired': isRequired }">

        <label :for="addressLineId" class="Form__Element__Caption kb-form-address-field-group__input-label">
            {{ addressLabel }}
        </label>

        <!-- Address line -->
        <input
            class="FormTextbox__Input kb-form-address-field-group__input kb-address-line"
            ref="addressLineInput"
            v-model="addressLine"
            :id="addressLineId"
            type="text"
            :aria-describedby="addressLineId"
            :aria-invalid="isValidationError"
            :placeholder="addressPlaceholder"
            :required="isRequired ? true : false"
            :onBlur="onchangeCallback ? onchangeCallback : ''"
            autocomplete="new-password"
            @input="clearSelectedAddress"
            :disabled="disabled"
        />
        <div aria-live="assertive">
            <p class="kb-forms Form__Element__ValidationError" role="alert" v-if="isValidationError">
                {{ errorMessageLabel }}
            </p>
        </div>

    </div>

    <div class="kb-form-address-field-group__input-row FormTextbox" :class="{ 'ValidationRequired': isRequired }">

        <div class="kb-form-address-field-group__input-wrapper kb-form-address-field-group__input-wrapper--shorter">

            <label :for="zipCodeId" class="Form__Element__Caption kb-form-address-field-group__input-label">
                {{ zipCodeLabel }}
            </label>

            <input
                class="FormTextbox__Input kb-form-address-field-group__input kb-form-address-field-group__input--shorter kb-form-address-field-group__pbs-input kb-address-zipcode"
                :class="{
                    'validation-error': isValidationError
                }"
                v-model="zipCode"
                :required="isRequired ? true : false"
                :id="zipCodeId"
                type="text"
                :disabled="!addressServiceUnavailable"
                :placeholder="zipCodePlaceholder"
            />

        </div>

        <div class="kb-form-address-field-group__input-wrapper FormTextbox"
            :class="{ 'ValidationRequired': isRequired }">

            <label :for="cityId"
                class="Form__Element__Caption kb-form-address-field-group__input-label">
                {{ cityLabel }}
            </label>

            <input
                class="FormTextbox__Input kb-form-address-field-group__input kb-address-city"
                :class="{
                    'validation-error': isValidationError
                }"
                v-model="city"
                :required="isRequired ? true : false"
                :id="cityId"
                type="text"
                :disabled="!addressServiceUnavailable"
                :placeholder="cityPlaceholder"
            />

        </div>

    </div>
</template>
